// extracted by mini-css-extract-plugin
export default {"cellTabContainer":"CellsTab_cellTabContainer__k3uGG","node":"CellsTab_node__Ker+i","description":"CellsTab_description__UR9pJ","actions":"CellsTab_actions__42O5M"};